export const directoryCode = {
    PARTNER: 0,
    MARKETING: 1,
    TALENT: 2,
    TECH: 3,
    TRANSFORM: 4,
};

export const directoryOptions = [
    { name: 'Talent', code: 2 },
    { name: 'Tech', code: 3 },
    { name: 'Transform', code: 4 },
];
export const directoryTypes = [
    { name: 'Partner', code: 0 },
    { name: 'Marketing', code: 1 },
    { name: 'Talent', code: 2 },
    { name: 'Tech', code: 3 },
    { name: 'Transform', code: 4 }
];

export const directoryTree = async () => {
    try {
        const response = await fetch(`${process.env.VUE_APP_ANSWER_BANK_SERVICE_URL}v2/question-set/list`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();

        // Create map to store parent nodes
        const treeMap = new Map();
        const tree = [];
        
        // First pass - create all top-level nodes
        data.data.forEach(item => {
            const parts = item.full_name.split(':');
            const topLevel = parts[0];
            
            if (!treeMap.has(topLevel)) {
                const node = {
                    key: item.name === 'profile' ? '-1' : topLevel,
                    label: topLevel,
                    data: topLevel,
                    icon: null,
                    children: []
                };
                tree.push(node);
                treeMap.set(topLevel, node);
            }
        });

        // Sort the top-level nodes
        tree.sort((a, b) => {
            const order = ['Talent', 'Technology', 'Transformation'];
            return order.indexOf(a.label) - order.indexOf(b.label);
        });

        // Second pass - create intermediate nodes and leaf nodes
        data.data.forEach(item => {
            const parts = item.full_name.split(':');
            
            if (parts.length > 1) {
                const topParent = treeMap.get(parts[0]);
                
                if (parts.length === 2) {
                    // Create second-level nodes
                    const node = {
                        key: item.full_name,
                        label: parts[1],
                        data: item.id,
                        icon: 'pi pi-fw pi-star',
                        style: {},
                        descriptionHtml: ''
                    };
                    
                    if (!topParent.children.some(child => child.key === item.full_name)) {
                        topParent.children.push(node);
                    }
                } else if (parts.length === 3) {
                    // Handle third-level nodes
                    let intermediateKey = `${parts[0]}:${parts[1]}`;
                    let intermediateParent = topParent.children.find(child => child.key === intermediateKey);
                    
                    // Create intermediate parent if it doesn't exist
                    if (!intermediateParent) {
                        intermediateParent = {
                            key: intermediateKey,
                            label: parts[1],
                            data: `${parts[1]} Products`,
                            icon: null,
                            children: []
                        };
                        topParent.children.push(intermediateParent);
                    }

                    // Create leaf node
                    const leafNode = {
                        key: item.full_name,
                        label: parts[2],
                        data: item.id,
                        icon: 'pi pi-fw pi-star',
                        style: {},
                        descriptionHtml: ''
                    };

                    intermediateParent.children.push(leafNode);
                }
            }
        });
        console.log('tree', tree);
        return tree;

    } catch (error) {
        console.error('Error fetching directory tree:', error);
        return [];
    }
};


// export const directoryTree = [
    // {
    //     key: '-1',
    //     label: 'Talent',
    //     data: 'Talent',
    //     children: [
    //         {
    //             key: 'Talent',
    //             descriptionHtml:
    //                 '<p>Fill out this form to describe your Business Process Outsourcing talents, experience and capabilities.  This allows us to match you to the best incoming opportunities.</p>',
    //             label: 'Talent',
    //             data: 2,
    //             icon: 'pi pi-fw pi-star',
    //         },
    //     ],
    // },
//     {
//         key: 'Technology',
//         label: 'Technology',
//         data: 'Technology',
//         icon: null, //"pi pi-fw pi-inbox",

//         children: [
//             {
//                 key: 'Technology:Software',
//                 label: 'Software',
//                 data: 'Software Products',
//                 icon: null, //"pi pi-fw pi-cog",
//                 children: [
//                     {
//                         key: 'Technology:Software:Customer Service & Engagement',
//                         label: 'Customer Service & Engagement',
//                         data: 12,
//                         icon: 'pi pi-fw pi-star',
//                         style: {},
//                         descriptionHtml: '',
//                     },
//                     {
//                         key: 'Technology:Software:Contact Center as a Service',
//                         label: 'Contact Center as a Service',
//                         data: 13,
//                         icon: 'pi pi-fw pi-star',
//                         style: {},
//                         descriptionHtml: '',
//                     },
//                     {
//                         key: 'Technology:Software:Conversational AI & Chatbots',
//                         label: 'Conversational AI & Chatbots',
//                         data: 14,
//                         icon: 'pi pi-fw pi-star',
//                         style: {},
//                         descriptionHtml: '',
//                     },
//                     {
//                         key: 'Technology:Software:Quality, Training, Agent Assist',
//                         label: 'Quality, Training, Agent Assist',
//                         data: 15,
//                         icon: 'pi pi-fw pi-star',
//                         style: {},
//                         descriptionHtml: '',
//                     },
//                     {
//                         key: 'Technology:Software:Customer & Agent Analytics',
//                         label: 'Customer & Agent Analytics',
//                         data: 16,
//                         icon: 'pi pi-fw pi-star',
//                         style: {},
//                         descriptionHtml: '',
//                     },
//                     {
//                         key: 'Technology:Software:Customer Relationship Management',
//                         label: 'Customer Relationship Management',
//                         data: 17,
//                         icon: 'pi pi-fw pi-star',
//                         style: {},
//                         descriptionHtml: '',
//                     },
//                     {
//                         key: 'Technology:Software:Video, Telephony, Carriers',
//                         label: 'Video, Telephony, Carriers',
//                         data: 18,
//                         icon: 'pi pi-fw pi-star',
//                         style: {},
//                         descriptionHtml: '',
//                     },
//                     {
//                         key: 'Technology:Software:Contact Center Accessibility',
//                         label: 'Contact Center Accessibility',
//                         data: 19,
//                         icon: 'pi pi-fw pi-star',
//                         style: {},
//                         descriptionHtml: '',
//                     },
//                     {
//                         key: 'Technology:Software:Customer Feedback',
//                         label: 'Customer Feedback',
//                         data: 20,
//                         icon: 'pi pi-fw pi-star',
//                         style: {},
//                         descriptionHtml: '',
//                     },
//                     {
//                         key: 'Technology:Software:Workforce Management',
//                         label: 'Workforce Management',
//                         data: 21,
//                         icon: 'pi pi-fw pi-star',
//                         style: {},
//                         descriptionHtml: '',
//                     },
//                     {
//                         key: 'Technology:Software:Contact Center Compliance, Reputation, Security',
//                         label: 'Contact Center Compliance, Reputation, Security',
//                         data: 22,
//                         icon: 'pi pi-fw pi-star',
//                         style: {},
//                         descriptionHtml: '',
//                     },
//                 ],
//             },
//             {
//                 key: 'Technology:Hardware',
//                 label: 'Hardware',
//                 data: 10,
//                 icon: 'pi pi-fw pi-star',
//                 style: {},
//                 descriptionHtml: '',
//             },
//         ],
//     },
//     {
//         key: 'Transformation',
//         label: 'Transformation',
//         data: 'Transformation Directory',
//         icon: null, //"pi pi-fw pi-inbox",

//         children: [
//             {
//                 key: 'Transformation:Consulting',
//                 label: 'Consulting',
//                 data: 5,
//                 icon: 'pi pi-fw pi-star',
//                 style: {},
//                 descriptionHtml: '',
//             },
//             {
//                 key: 'Transformation:Systems Integration',
//                 label: 'Systems Integration',
//                 data: 6,
//                 icon: 'pi pi-fw pi-star',
//                 style: {},
//                 descriptionHtml: '',
//             },
//             {
//                 key: 'Transformation:Managed Services',
//                 label: 'Managed Services',
//                 data: 7,
//                 icon: 'pi pi-fw pi-star',
//                 style: {},
//                 descriptionHtml: '',
//             },
//             {
//                 key: 'Transformation:Recruiting',
//                 label: 'Recruiting',
//                 data: 8,
//                 icon: 'pi pi-fw pi-star',
//                 style: {},
//                 descriptionHtml: '',
//             },
//             {
//                 key: 'Transformation:Training',
//                 label: 'Training',
//                 data: 4,
//                 icon: 'pi pi-fw pi-star',
//                 style: {},
//                 descriptionHtml: '',
//             },
//         ],
//     },
// ];
